import { useMemo, useState } from "react";
import { popularComics } from "@/mocks/banana";

export default function Popular() {
  const tabs = useMemo(
    () => ["全部", ...Array.from(new Set(popularComics.map((c) => c.tag)))],
    [],
  );
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () =>
      active === "全部"
        ? popularComics
        : popularComics.filter((c) => c.tag === active),
    [active],
  );

  return (
    <section id="popular" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
              <i className="ri-fire-fill" />
              热门推荐
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              大家都在追的热门漫画
            </h2>
          </div>

          <div className="flex flex-wrap gap-2 rounded-full bg-background-100 p-1.5">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === tab
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {list.map((comic) => (
            <article
              key={comic.title}
              className="group relative overflow-hidden rounded-2xl bg-background-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={comic.image}
                  alt={`${comic.title}漫画封面，${comic.tag}`}
                  title={`香蕉漫画 热门漫画《${comic.title}》`}
                  className="h-60 w-full object-cover transition-transform duration-500 group-hover:scale-110 md:h-72"
                />
                <span className="absolute left-3 top-3 rounded-full bg-black/50 px-2.5 py-1 text-xs font-medium text-white backdrop-blur-sm">
                  {comic.tag}
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-0.5 rounded-full bg-accent-500 px-2 py-1 text-xs font-bold text-background-50">
                  {comic.score}
                </span>
              </div>
              <div className="p-4">
                <h3 className="truncate text-base font-semibold text-foreground-950">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600">
                  {comic.author} · {comic.episodes}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs font-medium text-secondary-600">
                    <i className="ri-arrow-up-line" />
                    {comic.trend} 热度
                  </span>
                  <a
                    href="#download"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-700 hover:text-primary-800"
                  >
                    开始阅读 <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}